import React, { Component, Fragment } from "react";
import "./form.css";
import ButtonLoadingSpinner from "../form/ButtonLoadingSpinner";
import Input from "./input";
import Joi from "joi-browser";
import Select from "./select";
import TextArea from "./textArea";

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            message: "",
            showSuccessMessage: false,
            showErrorMessage:false
        }
    };

    validate = () => {
        const options = { abortEarly: false };
        const { error } = Joi.validate(this.state.data, this.schema, options);
        if (!error) return null;

        // const errors = {};
        // for (let item of error.details) errors[item.path[0]] = item.message;
        return error;
    };

    validateProperty = ({ name, value }) => {
        const obj = { [name]: value };
        const schema = { [name]: this.schema[name] };
        const { error } = Joi.validate(obj, schema);
        return error ? error.message : null;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validate();
        this.setState({ errors: errors || {} });
        if (errors) return;

        const isLoading = true;
        this.setState({ isLoading: isLoading });
        this.doSubmit();
    };

    handleChange = ({ currentTarget: input }) => {
        const errors = { ...this.state.errors };
        const errorMessage = this.validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];

        const data = { ...this.state.data };
        data[input.name] = input.value;

        this.setState({ data, errors });
    };

    renderButton(label) {
        return (
            <button
                disabled={this.validate() === null ? false : true}
                className="btn btn-primary btn-round btn-block"
            >
                {label}
            </button>
        );
    }

    renderButtonWithSpinner(label, className) {
        return (
            <Fragment>
                <button
                    disabled={this.validate() === null ? false : true}
                    className={className}
                >
                    {label}
                </button>
                {this.state.isLoading ? <ButtonLoadingSpinner /> : <div></div>}
                {this.state.showSuccessMessage ?
                    <div className="showSuccessMessage">عملیات با موفقیت انجام شد</div>
                    : <div></div>
                }
                {this.state.showErrorMessage ?
                    <div className="showErrorMessage">خطایی رخ داد</div>
                    : <div></div>
                }
            </Fragment>
        );
    }

    renderSelect(name, label, options) {
        const { data, errors } = this.state;

        return (
            <Select
                name={name}
                value={data[name]}
                label={label}
                options={options}
                onChange={this.handleChange}
                error={errors[name]}
            />
        );
    }

    renderInput(name, label, placeholder = "", type = "text", className = "", isRequired = "false") {
        const { data, errors } = this.state;

        return (
            <Input
                type={type}
                name={name}
                value={data[name]}
                label={label}
                placeholder={placeholder}
                onChange={this.handleChange}
                error={errors[name]}
                className={className}
                isRequired={isRequired}
            />
        );
    }

    renderTextArea(name, placeholder = "", className = "", rowsNumber = 3, isRequired = "false") {
        const { data, errors } = this.state;

        return (
            <TextArea
                className={className}
                placeholder={placeholder}
                rows={rowsNumber}
                name={name}
                value={data[name]}
                onChange={this.handleChange}
                isRequired={isRequired}
                error={errors[name]}
            />
        );
    }
}

export default Form;
